import { api } from "./api";

export const analyticsConsent = () => localStorage.getItem("tw_analytics_consent"); // "granted" | "denied" | null
export const setAnalyticsConsent = (v) => localStorage.setItem("tw_analytics_consent", v);

export function track(event, props = {}) {
  if (analyticsConsent() !== "granted") return;
  const clean = {};
  ["item", "bundle_key", "plan_key", "location_id", "transaction_id"].forEach((k) => {
    if (props[k] != null) clean[k] = String(props[k]);
  });
  clean.device = window.innerWidth < 768 ? "mobile" : "desktop";
  api.post("/analytics/events", { event, props: clean, consent: true }).catch(() => {});
}
